import React from "react";
import { Icon } from "../../../personal-studio-components/frame";
import * as cls from "./legendLingraph.module.scss";
function LegendLingraph(props) {
  return (
    <div className={cls.root}>
      <div className={cls.miniContainer}>
        <div className={cls.section_icon}>
          <Icon name="ruble" className={cls.iconRuble} />
        </div>
        <div>&nbsp;- Оплатить</div>
      </div>
      <div className={cls.miniContainer}>
        <Icon name="double_arrows" className={cls.icon} />
        <div>&nbsp;- Смена дисциплины по выбору</div>
      </div>
      <div className={cls.miniContainer}>
        <div className={cls.gradient}></div>
        <div>&nbsp;- Каникулы</div>
      </div>
      <div className={cls.miniContainer}>
        <span style={{ color: "rgb(178, 211, 62)" }}>
          <Icon name="check" className={cls.icon} />
        </span>
        <div>&nbsp;- Освоено</div>
      </div>
    </div>
  );
}

export default LegendLingraph;
